import type { ISectionBrowserProps } from 'components/SearchPage/components/SectionBrowser/SectionBrowser';
import { SectionBrowser } from 'components/SearchPage/components/SectionBrowser/SectionBrowser';
import { InputButton } from 'components/Toolkit/InputButton/InputButton';
import { BottomSheet } from 'components/Toolkit/BottomSheet/BottomSheet';
import { useState } from 'react';

export interface ISectionBrowserDropdownProps extends ISectionBrowserProps {}

function SectionBrowserDropdown({
  onSelectSection,
  onSelectBack,
  ...sectionsProps
}: ISectionBrowserDropdownProps) {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState<boolean>(false);

  const openBottomSheet = () => setIsBottomSheetOpen(true);
  const closeBottomSheet = () => setIsBottomSheetOpen(false);

  const handleSelectSection = (section: string) => {
    onSelectSection(section);
    closeBottomSheet();
  };

  const handleSelectBack = (section: string) => {
    onSelectBack(section);
    closeBottomSheet();
  };

  return (
    <div>
      <InputButton
        onClick={openBottomSheet}
        placeholder={sectionsProps.currentSection.displayName}
        isActive={isBottomSheetOpen}
      />
      <BottomSheet
        headerText={sectionsProps.currentSection.displayName}
        onApply={closeBottomSheet}
        askToClose={closeBottomSheet}
        isOpen={isBottomSheetOpen}
      >
        <SectionBrowser
          collapsible={false}
          onSelectSection={handleSelectSection}
          onSelectBack={handleSelectBack}
          {...sectionsProps}
        />
      </BottomSheet>
    </div>
  );
}

export { SectionBrowserDropdown };
